<template>
    <div>

        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            <i class="fas fa-building mr-1"></i> Organizações
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row mb-2">
                <div class="col-sm-3">
                    <b-form-group label="Código">
                        <b-form-input
                            v-model="filter.code"
                            placeholder="Buscar por código ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-3">
                    <b-form-group label="Nome">
                        <b-form-input
                            v-model="filter.name"
                            placeholder="Buscar por nome do professor/organização ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-3">
                    <b-form-group label="Email">
                        <b-form-input
                            v-model="filter.email"
                            placeholder="Buscar por email do professor/organização ..."
                            debounce="500"
                        ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-sm-3">
                    <!-- Field -->
                    <b-form-group label="Premium ?">
                        <multiselect
                            v-model="premium"
                            :options="premiumOptions"
                            :loading="loading"
                            track-by="id"
                            label="name"
                            placeholder=""
                            @select="selectPremium"
                            @remove="removePremium"
                            tag-placeholder="Filtrar Premium"
                            selectLabel="Selecionar"
                            deselectLabel="Desmarcar"
                            selectedLabel="Selecionado">

                                <span slot="noResult">
                                    Ops! Nenhum resultado encontrado na pesquisa :(
                                </span>

                                <span slot="noOptions">
                                    Não há status da redação para exibir no momento :(
                                </span>

                        </multiselect>
                    </b-form-group>
                </div>
            </div>

            <b-card class="mb-4">
                <b-skeleton-wrapper :loading="loading">

                    <template #loading>
                        <b-skeleton-table
                            :rows="lastResultsCount"
                            :columns="6"
                            :table-props="{ bordered: true, striped: true }"
                        >
                        </b-skeleton-table>
                    </template>

                    <b-table
                        id="organizationsTable"
                        :items="tableContent"
                        :fields="fields"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        @sort-changed="changeSortable"
                        empty-text="Não encontramos nenhum resultado na busca :("
                        class="bg-white mb-0"
                        stacked="md"
                        :sticky-header="true"
                        select-mode="single"
                        show-empty
                        no-local-sorting
                        bordered
                        hover>

                        <template v-slot:cell(name)="row">
                            <span v-if="row.item.name" v-b-tooltip.hover :title="row.item.name">
                                {{ row.item.name }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(domain)="row">
                            <span v-if="row.item.domain" v-b-tooltip.hover :title="row.item.domain">
                                <a :href="'https://' + row.item.domain" target="_blank">
                                    {{ row.item.domain }}
                                </a>
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(ownerPremium)="row">
                            <span v-if="row.item.teacher_owner.premium">
                                <i class="fas fa-circle mr-1 text-success"></i> Sim
                            </span>
                            <span v-else>
                                <i class="fas fa-circle mr-1 text-danger"></i> Não
                            </span>
                        </template>

                        <template v-slot:cell(students_count)="row">
                            <span v-if="row.item.students_count" class="text-nowrap">
                                {{ row.item.students_count }}

                                <b-button type="button" size="sm" class="p-1 m-0 ml-2" variant="light" @click="openStatistics(row.item.id)">
                                    <i class="fas fa-history"></i>
                                </b-button>
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(ownerDueDate)="row">
                            <span v-if="row.item.teacher_owner.due_date">
                                {{ row.item.teacher_owner.due_date | moment('DD/MM/YYYY') }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </template>

                        <template v-slot:cell(created_at)="row">
                            <span v-b-tooltip.hover :title="row.item.created_at | moment('DD/MM/YYYY HH:mm')">
                                {{ row.item.created_at | moment('from', 'now') }}
                            </span>
                        </template>

                        <template v-slot:cell(actions)="row">

                            <div class="text-center">
                                <a href="javascript:void(1)" @click="row.toggleDetails" v-b-tooltip.hover title="Detalhes da Organização">
                                    <i v-if="row.detailsShowing" class="fas fa-minus-square"></i>
                                    <i v-else class="fas fa-plus-square"></i>
                                </a>
                            </div>

                        </template>

                        <template #row-details="row">
                            <div class="">
                                <div class="row mb-2">
                                    <div class="col-sm-3">
                                        <div class="font-weight-bold">
                                            Versão de Avaliação
                                        </div>
                                        <div>
                                            <span v-if="row.item.teacher_owner.trial_end">
                                                <span v-if="$moment().isAfter(row.item.teacher_owner.trial_end)" class="text-danger" v-b-tooltip.hover :title="row.item.teacher_owner.trial_end | moment('DD/MM/YYYY HH:mm')">
                                                    Acabou {{ row.item.teacher_owner.trial_end | moment('from', 'now') }}
                                                </span>
                                                <span v-else class="text-success" v-b-tooltip.hover :title="row.item.teacher_owner.trial_end | moment('DD/MM/YYYY HH:mm')">
                                                    Termina {{ row.item.teacher_owner.trial_end | moment('from', 'now') }}
                                                </span>
                                            </span>
                                            <span v-else>
                                                ---
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="font-weight-bold">
                                            Data de Vencimento
                                        </div>
                                        <div>
                                            <a class="mr-1" href="javascript:void(1);" @click="changeDueDate(row.item.teacher_owner)" v-b-tooltip.hover title="Alterar Próximo Vencimento">
                                                <i class="fas fa-edit"></i>
                                            </a>

                                            <span v-if="row.item.teacher_owner.due_date">
                                                {{ row.item.teacher_owner.due_date | moment('DD/MM/YYYY') }}

                                                <a class="ml-2" href="javascript:void(1);" @click="nextDueDate(row.item.teacher_owner)" v-b-tooltip.hover title="Marcar como Paga e Gerar Próximo Vencimento">
                                                    <i class="fas fa-hand-holding-usd"></i>
                                                </a>
                                            </span>
                                            <span v-else>
                                                ---
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-sm-3" v-if="!row.item.integration_stripe">
                                        <div class="font-weight-bold">
                                            Assinatura
                                        </div>
                                        <div class="d-flex align-content-center">

                                            <b-button v-if="row.item.teacher_owner.premium" variant="outline-danger" size="sm" @click="changePremium(row.item.teacher_owner.id, false)" :disabled="loadingPremium">
                                                <i class="fas fa-pause"></i>
                                            </b-button>

                                            <b-button v-else variant="outline-success" size="sm" @click="changePremium(row.item.teacher_owner.id, true)" :disabled="loadingPremium">
                                                <i class="fas fa-play"></i>
                                            </b-button>

                                            <span class="ml-2">
                                                <span v-if="row.item.teacher_owner.premium">
                                                    Assinatura está Ativa
                                                </span>
                                                <span v-else>
                                                    Assinatura está Desativada
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="font-weight-bold">
                                            Módulo de Cursos
                                        </div>
                                        <div class="d-flex align-content-center">

                                            <b-button v-if="row.item.module_courses" variant="outline-danger" size="sm" @click="changeModuleCourse(row.item.id, false)" :disabled="loadingModuleCourses">
                                                <i class="fas fa-pause"></i>
                                            </b-button>

                                            <b-button v-else variant="outline-success" size="sm" @click="changeModuleCourse(row.item.id, true)" :disabled="loadingModuleCourses">
                                                <i class="fas fa-play"></i>
                                            </b-button>

                                            <span class="ml-2">
                                                <span v-if="row.item.module_courses" class="text-success">
                                                    Módulo Ativo
                                                </span>
                                                <span v-else class="text-danger">
                                                    Módulo Desativado
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="">

                                    <div class="font-weight-bold mb-2">
                                        Professores
                                    </div>

                                    <div class="table-responsive">
                                        <table class="table table-bordered table-sm">
                                            <tr>
                                                <td>
                                                    <b>
                                                        Nome
                                                    </b>
                                                </td>
                                                <td>
                                                    <b>
                                                        Email
                                                    </b>
                                                </td>
                                                <td>
                                                    <b>
                                                        Telefone
                                                    </b>
                                                </td>
                                                <td>
                                                    <b>
                                                        Entrou
                                                    </b>
                                                </td>
                                                <td>
                                                    <b>
                                                        Ações
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr v-for="teacher in row.item.teachers" :key="teacher.id" :class="{'table-success': row.item.teacher_owner.id === teacher.id}">
                                                <td>
                                                    {{ teacher.name }}
                                                </td>
                                                <td>
                                                    {{ teacher.email }}
                                                </td>
                                                <td>
                                                    {{ teacher.phone }}
                                                </td>
                                                <td v-b-tooltip.hover :title="teacher.created_at | moment('DD/MM/YYYY HH:mm')">
                                                    {{ teacher.created_at | moment('from', 'now') }}
                                                </td>
                                                <td>
                                                    <b-button variant="outline-primary" size="sm" @click="loginTeacher(teacher.id)" :disabled="loadingLogin">
                                                        <i class="fas fa-sign-in-alt mr-1"></i>
                                                        entrar nessa conta
                                                    </b-button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                </div>

                            </div>
                        </template>

                    </b-table>
                </b-skeleton-wrapper>
            </b-card>

            <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                @change="changePagination"
            />

            <div class="mb-4">
                {{ total }} resultados encontrados.
            </div>
        </div>

        <!-- Show -->
        <show></show>

        <!-- Change Due Date -->
        <change-due-date @updated="load"></change-due-date>

        <!-- Statistics -->
        <statistics></statistics>
    </div>
</template>

<script>

import Show from './Show'
import ChangeDueDate from "./ChangeDueDate";
import Statistics from "./Statistics";

export default {
    components: {
        Show,
        ChangeDueDate,
        Statistics
    },
    props: [],
    data() {
        return {
            loading: false,
            loadingLogin: false,
            loadingPremium: false,
            table: [],
            perPage: 15,
            currentPage: 1,
            total: 0,
            sortBy: 'created_at',
            sortDesc: true,
            fields: [
                { key: 'code', label: 'Código'},
                { key: 'name', label: 'Nome', sortable: true},
                { key: 'domain', label: 'Domínio', sortable: true},
                { key: 'students_count', label: 'Qtd. de Alunos'},
                { key: 'teachers_count', label: 'Qtd. de Professores'},
                { key: 'ownerPremium', label: 'Assinante ?'},
                { key: 'ownerDueDate', label: 'Próx. Vencimento'},
                { key: 'created_at', label: 'Criada', sortable: true},
                { key: 'actions', label: '' }
            ],
            filter: {
                code: null,
                name: null,
                email: null,
                premium: null
            },
            lastResultsCount: 5,
            premium: null,
            premiumOptions: [
                {
                    id: 'only_premium',
                    name: 'Somente Premium'
                },
                {
                    id: 'no_premium',
                    name: 'Somente Não Premium'
                },
            ]
        }
    },
    computed: {
        tableContent() {
            let table = this.table;
            table.map((element, key) => {
                if (element.is_due_payment) {
                    table[key]._rowVariant = 'danger';
                }
            })
            return table;
        }
    },
    created() {
        this.load()
    },
    watch: {
        'filter.code': async function (value) {
            this.filter.code = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.name': async function (value) {
            this.filter.name = await value;
            this.currentPage = 1
            await this.load()
        },
        'filter.email': async function (value) {
            this.filter.email = await value;
            this.currentPage = 1
            await this.load()
        },
    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/admin/organizations', {
                params: {
                    code: this.filter.code,
                    name: this.filter.name,
                    email: this.filter.email,
                    premium: this.filter.premium,

                    page: this.currentPage,
                    limit: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc ? 'desc': 'asc'
                }
            })
                .then((result) => {
                    const response = result.data.data;

                    this.table = response.organizations.data
                    this.currentPage = response.organizations.current_page
                    this.perPage = response.organizations.per_page
                    this.total = response.organizations.total

                    this.lastResultsCount = response.organizations.data.length

                })
                .finally(() => this.loading = false)
        },

        async changePagination(page) {
            this.currentPage = await page;
            this.load()
        },

        async changeSortable(context) {
            this.sortBy = await context.sortBy;
            this.sortDesc = await context.sortDesc
            this.load()
        },

        async selectPremium(value) {
            this.filter.premium = await value.id;

            // Load
            await this.load()
        },

        async removePremium() {
            this.filter.premium = await null

            // Load
            await this.load()
        },

        loginTeacher(id) {
            this.loadingLogin = true;
            axios.post('/admin/teachers/' + id + '/login')
                .then((result) => {
                    const response = result.data.data;

                    if (response.login) {
                        window.open('/teacher/dashboard', '_blank');
                    }

                })
                .finally(() => this.loadingLogin = false)
        },

        changeDueDate(teacher) {
            this.$root.$emit('changeDueDate', teacher);
        },

        nextDueDate(teacher) {
            this.$bvModal.msgBoxConfirm('Deseja realmente marcar como paga e gerar a próxima ?', {
                cancelTitle: 'Cancelar',
                okTitle: 'Paga e Gerar Próxima',
                cancelVariant: 'default',
                okVariant: 'primary'
            }).then(answer => {
                if (answer) {
                    this.loading = true;
                    axios.put('/admin/teachers/' + teacher.id + '/next-due-date')
                        .then((result) => {

                            // Message
                            this.$toast.success('Data de vencimento alterada com sucesso :)');

                            // Load
                            this.load()

                        })
                        .finally(() => this.loading = false)
                }
            })
        },

        changePremium(id, premium) {
            this.loadingPremium = true;
            axios.put('/admin/teachers/' + id + '/premium', {
                premium: premium
            })
                .then((result) => {
                    // Message
                    this.$toast.success('Assinatura alterada com sucesso :)');

                    // Load
                    this.load()
                })
                .finally(() => this.loadingPremium = false)
        },

        changeModuleCourse(id, module_courses) {
            this.loadingPremium = true;
            axios.put('/admin/organizations/' + id + '/courses', {
                module_courses: module_courses
            })
                .then((result) => {
                    // Message
                    this.$toast.success('Módulo de cursos alterado com sucesso :)');

                    // Load
                    this.load()
                })
                .finally(() => this.loadingPremium = false)
        },

        openStatistics(organizationId) {
            this.$root.$emit('showStatistics', organizationId)
        }

    }
}
</script>

<style scoped>
</style>
